export const SET = 'worker/SET';
export const SET_IN_WORK_TIMES = 'worker/SET_IN_WORK_TIMES';

export function setWorker(value) {
  return {
    type: SET,
    value
  }
}
export function setInWorkTimes(value) {
  return {
    type: SET_IN_WORK_TIMES,
    value
  }
}